// extracted by mini-css-extract-plugin
export default {"keys":"keys_keys__TIdim","key":"keys_key__sCIKH","down":"keys_down__hmpKe","correct":"keys_correct__pRY4H","labeled":"keys_labeled__foHfj"};